import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { SharedModule } from '../shared/shared.module';
import { SidenavComponent } from './sidenav/sidenav.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { AcceptInviteComponent } from './accept-invite/accept-invite.component';

@NgModule({
  declarations: [LoginComponent, AcceptInviteComponent, SidenavComponent, ToolbarComponent],
  imports: [CommonModule, SharedModule],
  exports: [LoginComponent, AcceptInviteComponent, SidenavComponent, ToolbarComponent],
})
export class CoreModule {}
